export const sizes = {
  desktop: 1200,
  desktopLarge: 1800,
  phone: 599,
  tabletLandscape: 900,
  tabletPortrait: 600,
};

export const queries = {
  desktopLargePlus: `(min-width: ${sizes.desktopLarge}px)`,
  desktopPlus: `(min-width: ${sizes.desktop}px)`,
  phoneOnly: `(max-width: ${sizes.phone}px)`,
  tabletLandscapePlus: `(min-width: ${sizes.tabletLandscape}px)`,
  tabletPortraitPlus: `(min-width: ${sizes.tabletPortrait}px)`,
  // These queries are intended for use with design-system components
  // (Zapier Design System).
  phone: `(min-width: 0) and (max-width: 419px)`,
  phablet: `(min-width: 420px) and (max-width: 659px)`,
  tablet: `(min-width: 660px) and (max-width: 1023px)`,
  desktop: `(min-width: 1024px)`,
};

export const supports = {
  // Yes, this media query is counter-intuitive
  // Source: https://stackoverflow.com/a/42363147
  hover: '@media not all and (hover: none)',
};

export const Screen = {
  queries,
  sizes,
  supports,
};
